/** The sign-in pages (never a place to "return to" after signing in). */
const AUTH_PAGES = ['/login', '/signup', '/sign-up', '/verify-email', '/forgot-password', '/reset-password', '/set-new-password', '/auth0'];

export function isAuthPage(url: string): boolean {
  return AUTH_PAGES.some((page) => url === page || url.startsWith(page + '?') || url.startsWith(page + '/'));
}
